var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
export var minMaxMobile = function (min, max) { return "only screen and (min-width: ".concat(min, "px) and (max-width: ").concat(max - 1, "px)"); };
export var mobile = function (breakpoint) { return "only screen and (max-width: ".concat(breakpoint - 1, "px)"); };
export var reset = {
    alignItems: 'flex-start',
    borderCollapse: 'separate',
    borderSpacing: 0,
    color: 'black',
    display: 'block',
    fontFamily: '"Open Sans", Arial, sans-serif',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 'normal',
    justifyContent: 'flex-start',
    letterSpacing: 'normal',
    lineHeight: 'normal',
    listStyleType: 'none',
    margin: 0,
    padding: 0,
    textAlign: 'left',
    textIndent: 0,
    textTransform: 'none',
    textShadow: 'none',
    verticalAlign: 'baseline',
    wordSpacing: 'normal',
};
export var boundingBox = (_a = {
        position: 'relative',
        margin: '0 auto',
        padding: "".concat(16, "px ").concat(24, "px")
    },
    _a["@media ".concat(mobile(700))] = {
        padding: 0,
    },
    _a);
export var boundingBox1400 = __assign(__assign({}, boundingBox), { maxWidth: 1400, boxSizing: 'border-box' });
export var boundingBox1280 = __assign(__assign({}, boundingBox), { maxWidth: 1280, boxSizing: 'border-box' });
export var boundingBox960 = __assign(__assign({}, boundingBox), { maxWidth: 960, boxSizing: 'border-box' });
export var layoutWrapper = __assign(__assign({}, reset), (_b = { background: '#ffffff', border: '1px solid #cccccc', borderRadius: 2, boxSizing: 'border-box', marginBottom: 24, minHeight: 500 }, _b["@media ".concat(mobile(700))] = {
    border: 'none',
    marginBottom: 0,
    minHeight: 'auto',
}, _b));
export var layout = {
    minHeight: 500,
    padding: "0 ".concat(16, "px"),
};
export var noPadding = {
    minHeight: 500,
    padding: 0,
};
export var sideBarWrapper = {
    borderLeft: '1px solid #ccc',
};
export var sideBarContentWrapper = {
    minHeight: 500,
    borderLeft: '1px solid #ccc',
};
export var overviewContentWrapper = {
    margin: '32px 32px 0px 32px',
};
export var header = {
    marginBottom: 16,
};
export var bannerWrapper = {
    marginBottom: 16,
};
export var searchWrapper = {
    background: '#f5f5f5',
    borderBottom: '1px solid #cccccc',
    borderTop: 0,
    padding: 16,
};
export var searchWrapperSideBar = __assign(__assign({}, searchWrapper), { margin: "0 0 ".concat(16, "px 0") });
export var filterWrapper = {
    borderTop: 0,
    margin: "-".concat(16, "px 0 ").concat(16, "px 0"),
};
export var filterWrapperSideBar = __assign(__assign({}, filterWrapper), { margin: "0 0 ".concat(16, "px 0") });
// Section Title
export var sectionTitleWrapper = {
    alignItems: 'center',
    borderBottom: "".concat(1, "px solid ").concat('#2eab73'),
    color: '#2eab73',
    display: 'flex',
    fontWeight: '600',
    fontSize: 18,
    lineHeight: 1.45,
    margin: '15px 0',
    paddingBottom: 5,
};
/** @ignore */
export var collapse = {
    xs: (_c = {},
        _c["@media ".concat(mobile(700))] = {
            display: 'block',
        },
        _c),
    sm: (_d = {},
        _d["@media ".concat(mobile(700), ", ").concat(minMaxMobile(700, 860))] = {
            display: 'block',
        },
        _d),
    md: (_e = {},
        _e["@media ".concat(mobile(700), ", ").concat(minMaxMobile(700, 860), ", ").concat(minMaxMobile(860, 1024))] = {
            display: 'block',
        },
        _e),
};
export var collapseXs = collapse.xs;
export var collapseSm = collapse.sm;
export var collapseMd = collapse.md;
/** @ignore */
export var sectionTitleActionWrapperBreakpoints = {
    xs: (_f = {},
        _f["@media ".concat(mobile(700))] = {
            display: 'block',
            marginTop: 12,
        },
        _f),
    sm: (_g = {},
        _g["@media ".concat(mobile(700), ", ").concat(minMaxMobile(700, 860))] = {
            display: 'block',
            marginTop: 12,
        },
        _g),
    md: (_h = {},
        _h["@media ".concat(mobile(700), ", ").concat(minMaxMobile(700, 860), ", ").concat(minMaxMobile(860, 1024))] = {
            display: 'block',
            marginTop: 12,
        },
        _h),
};
export var sectionTitleActionWrapperBreakpointsXs = sectionTitleActionWrapperBreakpoints.xs;
export var sectionTitleActionWrapperBreakpointsSm = sectionTitleActionWrapperBreakpoints.sm;
export var sectionTitleActionWrapperBreakpointsMd = sectionTitleActionWrapperBreakpoints.md;
export var sectionTitle = {
    alignItems: 'center',
    display: 'flex',
    flexGrow: 1,
    fontWeight: '600',
    fontSize: '18px',
    lineHeight: '27px',
};
// Header and Footer
export var headerWrapper = {
    alignItems: 'center',
    borderBottom: '1px solid #cccccc',
    display: 'flex',
    padding: 16,
    textAlign: 'left',
};
export var footerWrapper = __assign(__assign({}, headerWrapper), { borderBottom: 'none', borderTop: '1px solid #cccccc', justifyContent: 'flex-end' });
export var headerContent = {
    alignItems: 'center',
    display: 'flex',
    flexGrow: 1,
};
export var heading = (_j = {
        pointerEvents: 'none',
        margin: 0,
        display: 'block',
        fontSize: 26,
        fontWeight: '300',
        lineHeight: '36px',
        flexGrow: 1
    },
    _j["@media ".concat(mobile(700))] = {
        fontSize: 18,
        lineHeight: 24 + 'px',
    },
    _j);
export var titleWrapper = {
    display: 'inline-flex',
    pointerEvents: 'auto',
};
export var headerActionArea = {
    // flex: '0 0 auto',
    textAlign: 'right',
};
export var backIcon = (_k = {
        fontSize: 20
    },
    _k["@media ".concat(mobile(700).replace('max-width', 'maxWidth'))] = {
        fontSize: 18,
        fontWeight: 'normal',
    },
    _k);
export var backIconButton = {
    marginLeft: 16 * -1,
};
/** @ignore */
export var headerCollapse = {
    xs: (_l = {},
        _l["@media ".concat(mobile(700))] = {
            display: 'block',
        },
        _l),
    sm: (_m = {},
        _m["@media ".concat(mobile(700), ", ").concat(mobile(860))] = {
            display: 'block',
        },
        _m),
    md: (_o = {},
        _o["@media ".concat(mobile(700), ", ").concat(mobile(860), ", ").concat(mobile(1024))] = {
            display: 'block',
        },
        _o),
};
export var headerCollapseXs = headerCollapse.xs;
export var headerCollapseSm = headerCollapse.sm;
export var headerCollapseMd = headerCollapse.md;
export var headerCollapseAction = {
    xs: (_p = {},
        _p["@media ".concat(mobile(700))] = {
            marginTop: 12,
        },
        _p),
    sm: (_q = {},
        _q["@media ".concat(mobile(700), ", ").concat(mobile(860))] = {
            marginTop: 12,
        },
        _q),
    md: (_r = {},
        _r["@media ".concat(mobile(700), ", ").concat(mobile(860), ", ").concat(mobile(1024))] = {
            marginTop: 12,
        },
        _r),
};
export var pageHeader = {
    margin: "0 ".concat(16 * -1, "px"),
};
export var masonry = {
    display: 'flex',
    margin: '0 -8px -16px -8px',
    width: 'auto',
};
export var masonryColumn = {
    backgroundClip: 'padding-box',
    display: 'flex',
    flexDirection: 'column',
    margin: '0 8px',
    '> *:last-child': {
        flexGrow: 1,
    },
    '> *': {
        height: 'auto !important',
        marginBottom: '16px',
    },
};
export var masonryColumnRagged = __assign(__assign({}, masonryColumn), { display: 'block' });
export var fullHeight = {
    height: '100%',
};
